var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97754 5L14.9905 10",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8135 18.334H18.3328",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66709 13.3397L13.3022 1.66991C13.3073 1.66476 13.3156 1.66471 13.3208 1.66981L18.3243 6.66654C18.3276 6.6698 18.3276 6.67506 18.3243 6.67832L6.66037 18.3329H1.66699L1.66709 13.3397Z",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.028112152eb6e32af278f6b66e6b47be.svg";
export { ForwardRef as ReactComponent };